<template>
    <div class="answer_wrap" :style="{
     height: currentValue.isShowMore?'auto':'auto',
  }">
        <div class="answer_title">
            <div class="tips">{{currentValue.questionTypeName}}</div>
            <div class="title_wrap">
                <div style="position: absolute">
                    <div class="status success" v-if="filterUserAnswerStatus(currentValue)  == 1">
                        <img src="../../assets/image/learnmodel/V@2x.png" alt="">
                        正确
                    </div>
                    <div class="status error" v-else-if="filterUserAnswerStatus(currentValue) == 0">
                        <img src="../../assets/image/learnmodel/cuo@2x.png" alt="">
                        错误
                    </div>
                    <div class="status" v-else-if="filterUserAnswerStatus(currentValue) == 2">
                        <!-- <img src="../../assets/image/learnmodel/cuo@2x.png" alt="">
                        半对 -->
                    </div>
                </div>
                <div class="title" v-html="currentValue.questionContent">

                </div>
            </div>

            <!-- <div v-if="filterUserAnswerStatus(currentValue) != -1" class="btn" @click="exit">
                取消
            </div> -->
        </div>
        <!-- 单选 -->
        <div style="padding-top:10px" v-if="currentValue.internalTypeId == 1">
            <el-radio-group v-model="content"  @change="submit">
                <el-radio v-for="(item,index) in currentValue.items" :key="index" :label="item.itemKey" >{{item.itemKey +'、'+ filterC(item.itemValue)}}
                </el-radio>
            </el-radio-group>
        </div>
        <div class="judge" style="padding-top:10px" v-else-if="currentValue.internalTypeId == 3">
            <el-radio-group v-model="content"  @change="submit">
                <el-radio label="正确">
                    <i class="el-icon-check"></i>
                </el-radio>
                <el-radio label="错误">
                    <i class="el-icon-close"></i>
                </el-radio>
            </el-radio-group>
        </div>
        <div style="padding-top:10px" v-else-if="currentValue.internalTypeId == 2">
            <el-checkbox-group v-model="content" @change="submit">
                <el-checkbox :class="errFilter(index)?'errStyle':''"  v-for="(item,index) in currentValue.items" :label="item.itemKey" :key="index">{{item.itemKey +'、'+ filterC(item.itemValue)}}
                </el-checkbox>
            </el-checkbox-group>
        </div>
    </div>
</template>
<script>
export default {
    name: "answer",
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        answerList:{
            type: Array,
            default:[]
        }
    },
  data(){
    return{
      currentValue:this.value,
      content:[],
      defalutArr:['A','B','C','D']//为了进行排序
    }
  },
    watch: {
      value:{
        handler(val) {
          this.currentValue = val;
        },
        immediate: true,
        deep: true,
      },
        content: {
            handler(val) {
                this.currentValue.check = val
                if(this.currentValue.answerDetail){
                    if(Array.isArray(val)){
                        let arr = val.filter((val,ind)=>{
                            return val!=''
                        })
                        let userAnswerArr = []
                        this.defalutArr.forEach((val,ind)=>{
                            arr.forEach((val1,ind1)=>{
                                if(val == val1){
                                    userAnswerArr.push(val)
                                }
                            })
                        })
                        this.currentValue.answerDetail.userAnswer = userAnswerArr.join(',')
                    }else{
                        this.currentValue.answerDetail.userAnswer = val
                    }
                }
            },
            deep: true,
        },
        answerList: {
            handler(newVal) {
              if (newVal && newVal.length){
                // console.log('--newVal--', newVal)
                this.init();
              }

            },
            deep: true,
        }
    },
    mounted(){
        setTimeout(()=>{
         this.init();
        },500)
    },
    methods:{
      init(){
        this.answerList.forEach((val,ind)=>{
          if(val.questionId == this.currentValue.id && val.userAnswer){
            if(this.currentValue.internalTypeId == 2){
              this.content = val.userAnswer.split(',')
            }else{
              this.content = val.userAnswer
            }
          }else{
            this.content = ''
          }
          this.$set(this.currentValue,'answerDetail',val)
        })
      },
        filterC(str){
            let reg=/<\/?.+?\/?>/g;
            return str.replace(reg,'')
        },
        errFilter(ind){
            let bol = false
            if(this.filterUserAnswerStatus(this.currentValue) == 0){ //错误
                if(this.currentValue.internalTypeId == 2){//多选
                    // 筛选错误选项
                    let a = new Set(this.currentValue.answerDetail.answer.split(','));
                    let b = new Set(this.currentValue.answerDetail.userAnswer.split(','));
                    // 并集
                    let unionSet = new Set([...a, ...b]);
                    // ab差集
                    let differenceABSet = new Set([...b].filter(x => !a.has(x)));
                    let errArr = Array.from(differenceABSet) //错误选项
                    this.defalutArr.forEach((val,index)=>{
                        errArr.forEach((val1,index1)=>{
                            if(val == val1 && ind == index){
                                bol =  true
                            }
                        })
                    })
                }
            }else{
                bol =  false
            }
            return bol
        },
        filterUserAnswerStatus(item){
            if(Object.keys(item).indexOf('answerDetail') == -1){
                return -1
            }
            if(Object.keys(item.answerDetail).indexOf('userAnswerStatus') == -1){
                return -1
            }
            return item.answerDetail.userAnswerStatus
        },
        submit(val){
          console.log('--2--', val)
            // this.$emit("submitAnswer", this.currentValue);
        }
    }
}
</script>
<style lang="scss" scoped>
.answer_wrap{
    width:100%;
    position:relative;
    box-sizing: border-box;
    overflow: hidden;
    background:rgba(0, 124, 237, 0.06);
    .answer_title{
        height: 60px;
        line-height: 60px;
        border-bottom: 2px solid #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tips{
          position:absolute;
          left:0;
          top:0;
          width: 68px;
          height: 18px;
          line-height: 18px;
          background: #FECB00;
          border-radius: 0px 0px 10px 10px;
          font-size:12px;
          color: #333;
          text-align: center;
        }
        .title_wrap{
            display: flex;
            align-content: center;
            justify-content: flex-start;
            .title{
                font-size: 14px;
                margin-left: 90px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #2B2A33;
                line-height: 60px;
            }
        }
        .status{
            img{
                width:13px;
                height:13px;
                margin-right:4px;
            }
            display: flex;
            align-items: center;
            margin-left:40px;
            font-size: 12px;
            color: #333333;
        }
        .btn{
            width: 73px;
            height: 30px;
            line-height: 30px;
            margin-right: 30px;
            text-align: center;
            border-radius: 2px;
            border: 1px solid #007DFF;
            font-size: 12px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #007FFF;
            cursor: pointer;
        }
    }
    .success{
        color: #A5E20D!important;
    }
    .error{
        color: #F52F3E!important;
    }
    .answer_content{
        margin-bottom: 15px;
        padding-left: 70px;
        line-height: 20px;
        margin-top: 15px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2B2A33;
    }
    /deep/ .el-checkbox__label,/deep/ .el-radio__label{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
    }
    /deep/ .el-checkbox-group,/deep/ .el-radio-group{
        padding-left: 15%;
        padding-right: 15%;
        display: flex;
        flex-direction: column;
        width: 70%;
    }
    /deep/ .el-radio{
        margin-bottom:7px;
        height: 30px;
        line-height: 30px;
    }
    .isShowbtn{
        position:absolute;
        right: 15px;
        bottom: 15px;
        .btn{
            font-size: 12px;
            color: #007FFF;
            text-decoration: underline;
            cursor: pointer;
        }
    }
}
/deep/ .is-checked{
    background: rgba(0, 124, 237, 0.11);
    border-radius: 4px;
    border: 1px solid #007CED!important;
}
/deep/ .el-checkbox__input,/deep/ .el-radio__input{
    display: none;
}
/deep/ .el-checkbox{
    margin-right: 0px;
    margin-bottom: 7px;
    line-height: 30px;
    height: 30px;
    box-sizing: border-box;
}
.judge /deep/ .el-radio{
    width: 30px;
    height: 30px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: 1px solid #666666;
    color: #666666;
    .el-radio__label{
        padding-left: 0px;
    }
}
.judge /deep/ .is-checked i{
    color: #007CED;
}
.judge /deep/ .el-radio-group{
    display: flex;
    flex-direction: row;
}
/deep/ .errStyle {
    background: rgba(245, 47, 62, 0.1);
    border-radius: 4px;
    border: 1px solid red!important;
}
</style>




// WEBPACK FOOTER //
// src/views/component/answer.vue